import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=8caf8358&scoped=true"
import script from "./Upcoming.vue?vue&type=script&lang=js"
export * from "./Upcoming.vue?vue&type=script&lang=js"
import style0 from "./Upcoming.vue?vue&type=style&index=0&id=8caf8358&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caf8358",
  null
  
)

export default component.exports